
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { NavLink } from 'react-router-dom';

interface ProfileErrorProps {
  error: string | null;
}

const ProfileError = ({ error }: ProfileErrorProps) => {
  return (
    <div className="bg-adv-dark min-h-screen pt-20">
      <div className="container-custom">
        <div className="glass-card rounded-lg p-12 text-center max-w-2xl mx-auto">
          <AlertTriangle size={48} className="text-adv-orange mb-4 mx-auto" />
          <h1 className="heading-lg text-white mb-4">User Not Found</h1>
          <p className="text-adv-lightGray mb-6">
            {error || "We couldn't find the user you're looking for."}
          </p>
          <Button className="btn-primary">
            <NavLink to="/ride-hub">
              Explore Rides
            </NavLink>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfileError;
